import React from 'react';
import { connect } from 'react-redux';
import './LoggedUser.css';
import { refreshView as refreshViewAction } from 'react-admin';
import { requestUser as requestUserAction } from '../redux/actions';
import { updateInformers as updateInformersAction } from '../redux/actions';
import { restClient } from '../common';


class LoggedUser extends React.Component {
  constructor(props) {
    super(props);
    this.props.requestUser();
  }

  componentWillMount() {
    const promiseList = [
      restClient('GET_CUSTOM', 'getInformersListRaw'),
    ];
    const isAdmin = this.getUserRole() === 'administrator';
    if (isAdmin) {
      promiseList.push(
        restClient('GET_CUSTOM', 'getUsersList'),
        restClient('GET_CUSTOM', 'getCallcentersPlanTree')
      );
    }

    Promise.all(promiseList).then(values => {
      const informers = {
        companies: values[0].companies,
        callcenters: values[0].callcenters,
        city: values[0].city,
        subjects: values[0].subjects
      };

      if (isAdmin) {
        informers.users = values[1].users;
        informers.plans = values[2];
      }
      this.props.updateInformers(informers);
      this.props.refreshView();
    });
  }

  getUserRole() {
    return localStorage.getItem('role');
  }

  getUserRoleName(role) {
    switch (role) {
      case 'administrator':
        return 'Админ';
      case 'callcenter_admin':
        return 'Админ КЦ';
      case 'callcenter_manager':
        return 'Менеджер КЦ';
      case 'company_admin':
        return 'Админ КП';
      case 'company_manager':
        return 'Менеджер КП';
      case 'qcd_admin':
        return 'Админ ОКК';
      default:
        return '';
    }
  }

  render() {
    const { user } = this.props;

    if (user) {
      return (
        <div className="LoggedUser">
          <span
            className="LoggedUserName"
            style={{
              fontFamily: 'Open Sans',
              color: '#E1E1E1',
              letterSpacing: 0,
              fontWeight: 300,
              fontSize: '12px'
            }}
          >{this.getUserRoleName(user.role)} — {user.name}  |
          </span>
          {this.props.logout}
        </div>
      );
    }
    return null;
  }
}

const mapDispatchToProps = dispatch => ({
  requestUser: () => {
    dispatch(requestUserAction());
  },
  updateInformers: (data) => {
    dispatch(updateInformersAction(data));
  },
  refreshView: () => {
    dispatch(refreshViewAction());
  },
});

export default connect(state => ({
  user: state.sc.user,
}), mapDispatchToProps)(LoggedUser);



// WEBPACK FOOTER //
// ./src/components/LoggedUser.js